import React from "react";
import DetailsModal from "../../../components/ModalDetailsGeneric/ModalDetailsGeneric";
import { CustomButtonVariant } from "../../../components/CustomButton/CustomButton";
import { ModalOrderLoaderProps } from "../models/ModalOrdes";
import { orderModalStatus } from "../../ConsultQuotaOrders/models/OptionsMenu";
import {
  IconType,
  StyledIcon,
} from "../../../components/StyledIcon/StyledIcon";
import {
  ORDER_STATUS,
  StatusOrderIcon,
  setStatusIcon,
} from "../../ConsultQuotaOrders/models/StatusOrderIcon";
import { buildQuotaOrderDetailItems } from "../utils/buildQuotaOrderDetailItems";

const ModalOrderLoader: React.FC<ModalOrderLoaderProps> = ({
  withTab,
  isOpen,
  data,
  isView,
  isApproved = false,
  handleClose,
}) => {
  const buttonsOrderApprovedWithoutCaveat = [
    {
      label: "Fechar",
      variant: CustomButtonVariant.CONTAINED,
      onClick: () => {
        handleClose(false, orderModalStatus.CLOSE);
      },
    },
  ];

  const buttonNewOrderRequest = [
    {
      label: "Salvar em rascunho",
      variant: CustomButtonVariant.OUTLINED,
      onClick: () => {
        handleClose(false, orderModalStatus.DRAFT);
      },
    },
    {
      label: "Realizar pedido",
      variant: CustomButtonVariant.CONTAINED,
      onClick: () => {
        handleClose(false, orderModalStatus.ORDER);
      },
    },
  ];

  const buttonSeeOrder = [
    {
      label: "Ver pedido completo",
      variant: CustomButtonVariant.OUTLINED,
      onClick: () => {
        handleClose(false, orderModalStatus.SEE_ORDER);
      },
    },
    {
      label: "Fechar",
      variant: CustomButtonVariant.CONTAINED,
      onClick: () => {
        handleClose(false, orderModalStatus.CLOSE);
      },
    },
  ];

  const status = data.status as keyof typeof StatusOrderIcon | undefined;
  const step = data.step as keyof typeof StatusOrderIcon | undefined;

  const statusIcon =
    status != null || step != null
      ? setStatusIcon(
          status as keyof typeof StatusOrderIcon,
          step as keyof typeof StatusOrderIcon
        )
      : undefined;

  const statusTooltip =
    step != null ? ORDER_STATUS[step] ?? "Solicitado" : undefined;

  const statusNode =
    statusIcon != null ? (
      <StyledIcon
        iconType={statusIcon as IconType}
        sx={{ width: 20, height: 20 }}
        tooltip={statusTooltip != null ? { title: statusTooltip } : undefined}
      />
    ) : undefined;

  return (
    <DetailsModal
      open={isOpen}
      onClose={() => handleClose(false, orderModalStatus.CLOSE)}
      title="Detalhes do pedido de cota"
      header={{
        title: data.header?.distributor?.value ?? "",
      }}
      data={buildQuotaOrderDetailItems(data, withTab, statusNode)}
      actions={
        isApproved
          ? buttonsOrderApprovedWithoutCaveat
          : isView
          ? buttonSeeOrder
          : buttonNewOrderRequest
      }
    />
  );
};

export default ModalOrderLoader;
